import { NameSpecifiedEntity } from "../../entity";

// 書類種別
export class ReceptionReportType extends NameSpecifiedEntity<string> {
  constructor(id: string, name: string) {
    super(id, name);
  }

  static areEqual(source: ReceptionReportType, dest: ReceptionReportType): boolean {
    return (source === dest)
     || (source && dest && (source.id === dest.id));
  }
}
